(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["tera-sample-order-update"]) return;
  try {
    
       var didScroll;
		var lastScrollTop = 900;
		var delta = 5;
		var navbarHeight = $('.sticky-header ').outerHeight();

		$(window).scroll(function(event){
		    didScroll = true;
		});

		setInterval(function() {
		    if (didScroll) {
		        hasScrolled();
		        didScroll = false;
		    }
		}, 250);
       function hasScrolled() {
		    var st = $(this).scrollTop();
		    
		    if(Math.abs(lastScrollTop - st) <= delta)
		        return;
		    
		    if (st > lastScrollTop && st > navbarHeight + 200){
		        $('.sticky-header').removeClass('scrolling_up').addClass('scrolling_down');
		    } else {
		        if(st +  $(window).height() < $(document).height()) {
		            $('.sticky-header').removeClass('scrolling_down').addClass('scrolling_up');
		        }
		    }
		    
		    lastScrollTop = st;
		}

  
  $('body').on('click', '.checkout-redirect', function(e) {
    window.location.href = '/checkout';
  });

  $('body').on('click', '.case-cylinder', function(e) {
    // $('.protect-special').prop("disabled", false);
  });
  
 
   $('body').on('click', '.protect-special', function(e) {
      // let discountCode = "PROTECTFREE";
      // applyCoupon(discountCode);
  });

  $('body').on('click', '.freeShipping', function(e) {
      let discountCode = "FREESHIPPING";
      applyCoupon(discountCode);
  });

  $('body').on('click', '.btn-select-all', function(e) {
    console.log("btn select all");
     $('.checkbox-product-sample').prop('checked', true);
     updateDataOnCheck($(this));
      var numCheckboxes = $('.checkbox-product-sample').length;
      var processedCheckboxes = 0;
      $('.checkbox-product-sample').each(function(index) {
        console.log("btn select  prr");
        var checkbox = $(this);
        setTimeout(function() {
          itemProperties(checkbox);
          processedCheckboxes++;
          if(processedCheckboxes === numCheckboxes) {
            // redirect to checkout after all checkboxes have been processed
            // window.location.href = "/checkout";
          }
        }, index * 1000);
      });
  });

  $('body').on('click', '.checkbox-product-sample', function(e) {
     updateDataOnCheck($(this));
      itemProperties($(this));
  });

  function updateDataOnCheck(objData) {
    var isChecked = false;
    var totalChecked = 0;
    var totalPrice = 0;
    $('.checkbox-product-sample').each(function(index) {
      var checkbox = $(this);
      if (checkbox.is(':checked')) {
        isChecked = true;
        totalChecked++;
        totalPrice += parseFloat(checkbox.attr("data-price"));
      }
    });
    
    var roundedNum = totalPrice.toFixed(2);

    $('.sample-recurring-total').text('$'+roundedNum);
    if (isChecked) {
      $('.sample-ship').text('$9.95');
    } else {
      $('.sample-ship').text('$0.00');
    }
  }
  
  function itemProperties(objData) {
    var planValue = objData.attr("name");
    var plan = objData.attr("data-plan");
    var id = objData.attr("value");
    var selling_plan = objData.attr("data-selling-plan");
    var section_price = parseFloat(objData.attr("data-price"));    
    if(!objData.is(':checked')) {
      data = {
          'id': id,
          'quantity': 0
      }
     removeItem(data);
    } else {
      var quantity = 1;
      data = {
        "id": id,
        "quantity": quantity
      }
      data["selling_plan"] = selling_plan;
      addItemToCartFree(data);
    }
  }
  
  
    var total_bliss = 0;
    var total_comfort = 0;
    var total_sleep = 0;
    var total_protect = 0;
    var total_azucare = 0;
  $('body').on('click', '.checkbox-product', function(e) {

    var totalChecked = $('input.checkbox-product:checked').length;
    console.log('totalChecked',totalChecked);

    var planValue = $(this).attr("name");
    var plan = $(this).attr("data-plan");
    var id = $(this).attr("value");
    var selling_plan = $(this).attr("data-selling-plan");
    var section_price = parseFloat($(this).attr("data-price"));
     // console.log('section_price'+section_price);
    
    if(!$(this).is(':checked')) {

      if ($(this).hasClass("bliss-section")) {
        total_bliss = parseFloat(total_bliss) - parseFloat(section_price);
      }
      if ($(this).hasClass("comfort-section")) {
        total_comfort = parseFloat(total_comfort) - parseFloat(section_price);
      }
      if ($(this).hasClass("sleep-section")) {
        total_sleep = parseFloat(total_sleep) - parseFloat(section_price);
      }
      if ($(this).hasClass("protect-section")) {
          total_protect = parseFloat(total_protect) - parseFloat(section_price);
      }
      if ($(this).hasClass("azucare-section")) {
          total_azucare = parseFloat(total_azucare) - parseFloat(section_price);
      }
      
      
      data = {
          'id': id,
          'quantity': 0
      }
     removeItem(data);
    } else {

      if ($(this).hasClass("bliss-section")) {
        total_bliss = parseFloat(total_bliss) + parseFloat(section_price);
      }
      if ($(this).hasClass("comfort-section")) {
        total_comfort = parseFloat(total_comfort) + parseFloat(section_price);
      }
      if ($(this).hasClass("sleep-section")) {
        total_sleep = parseFloat(total_sleep) + parseFloat(section_price);
      }
      if ($(this).hasClass("protect-section")) {
          total_protect = parseFloat(total_protect) + parseFloat(section_price);
      }
      if ($(this).hasClass("azucare-section")) {
          total_azucare = parseFloat(total_azucare) + parseFloat(section_price);
      }
      
      var quantity = 1;
      if(planValue == 'onetime') {
        quantity = 1;
      }
      
      if(planValue == 'get1free') {
        quantity = 3;
      }
      
      data = {
        "id": id,
        "quantity": quantity
      }
      if(planValue != 'onetime' && planValue != 'get1free') {
        data["selling_plan"] = selling_plan;
      }
      data[plan] = planValue;
      addItemToCartFree(data);
    }

    total_bliss = parseFloat(total_bliss).toFixed(2);
    total_comfort = parseFloat(total_comfort).toFixed(2);
    total_sleep = parseFloat(total_sleep).toFixed(2);
    total_protect = parseFloat(total_protect).toFixed(2);
    total_azucare = parseFloat(total_azucare).toFixed(2);
    $(".bliss-total").text('$'+total_bliss);
    $(".comfort-total").text('$'+total_comfort);
    $(".sleep-total").text('$'+total_sleep);
    $(".protect-total").text('$'+total_protect);
    $(".azucare-total").text('$'+total_azucare);

    var checkoutTotal = parseFloat(parseFloat(total_bliss) + parseFloat(total_comfort) + parseFloat(total_sleep) + parseFloat(total_protect)).toFixed(2);
    $(".checkout-total").text('Checkout - $'+checkoutTotal);
    let discountCode = "protectFreeSpecial";
    // applyCoupon(discountCode);
  });

  function addItemToCartFree(data) {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
         }));
        // OpenDrawer();
      }
    });
  }

  function applyCoupon(discountCode) {
    // Setup the Apply Discount Code URL
    let shopDomain = "www.teranaturals.com";
    let discountApplyUrl = "https://" + shopDomain + "/discount/" + discountCode;
    	
    // Applies discount using hidden iframe to the checkout session
    let i = document.createElement('iframe');
    i.style.display = 'none';
    i.onload = function() { i.parentNode.removeChild(i); };
    i.src=discountApplyUrl;
    document.body.appendChild(i);
  }

  function removeItem(data) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data:data
        }).then(data => {
          console.log("removeddd");
      })
  }
  
  function OpenDrawer(){
       document.documentElement.dispatchEvent(new CustomEvent('product:added', {
         bubbles: true,
              detail: {
                variant: "",
                quantity: 0
              }
          }));
    
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tera-sample-order"]) return;
  try {
    
       var didScroll;
		var lastScrollTop = 900;
		var delta = 5;
		var navbarHeight = $('.sticky-header ').outerHeight();

		$(window).scroll(function(event){
		    didScroll = true;
		});

		setInterval(function() {
		    if (didScroll) {
		        hasScrolled();
		        didScroll = false;
		    }
		}, 250);
       function hasScrolled() {
		    var st = $(this).scrollTop();
		    
		    if(Math.abs(lastScrollTop - st) <= delta)
		        return;
		    
		    if (st > lastScrollTop && st > navbarHeight + 200){
		        $('.sticky-header').removeClass('scrolling_up').addClass('scrolling_down');
		    } else {
		        if(st +  $(window).height() < $(document).height()) {
		            $('.sticky-header').removeClass('scrolling_down').addClass('scrolling_up');
		        }
		    }
		    
		    lastScrollTop = st;
		}

  
  $('body').on('click', '.checkout-redirect', function(e) {
    if (!$('#check1').prop('checked')) {
      $('#terms-error').show();
      alert('Please agree to the terms and conditions');
      return;
    }
    window.location.href = '/checkout';
  });

  $('body').on('click', '.case-cylinder', function(e) {
    // $('.protect-special').prop("disabled", false);
  });
  
 
   $('body').on('click', '.protect-special', function(e) {
      // let discountCode = "PROTECTFREE";
      // applyCoupon(discountCode);
  });

  $('body').on('click', '.freeShipping', function(e) {
      let discountCode = "FREESHIPPING";
      applyCoupon(discountCode);
  });

  $('body').on('click', '.btn-select-all', function(e) {
    console.log("btn select all");
     $('.checkbox-product-sample').prop('checked', true);
     updateDataOnCheck($(this));
      var numCheckboxes = $('.checkbox-product-sample').length;
      var processedCheckboxes = 0;
      $('.checkbox-product-sample').each(function(index) {
        console.log("btn select  prr");
        var checkbox = $(this);
        setTimeout(function() {
          itemProperties(checkbox);
          processedCheckboxes++;
          if(processedCheckboxes === numCheckboxes) {
            // redirect to checkout after all checkboxes have been processed
            // window.location.href = "/checkout";
          }
        }, index * 1000);
      });
  });

  $('body').on('click', '.checkbox-product-sample', function(e) {
     updateDataOnCheck($(this));
      itemProperties($(this));
  });

  function updateDataOnCheck(objData) {
    var isChecked = false;
    var totalChecked = 0;
    var totalPrice = 0;
    $('.checkbox-product-sample').each(function(index) {
      var checkbox = $(this);
      if (checkbox.is(':checked')) {
        isChecked = true;
        totalChecked++;
        totalPrice += parseFloat(checkbox.attr("data-price"));
      }
    });
    
    var roundedNum = totalPrice.toFixed(2);

    $('.sample-recurring-total').text('$'+roundedNum);
    if (isChecked) {
      $('.sample-ship').text('$9.95');
    } else {
      $('.sample-ship').text('$0.00');
    }
  }
  
  function itemProperties(objData) {
    var planValue = objData.attr("name");
    var plan = objData.attr("data-plan");
    var id = objData.attr("value");
    var selling_plan = objData.attr("data-selling-plan");
    var section_price = parseFloat(objData.attr("data-price"));    
    if(!objData.is(':checked')) {
      data = {
          'id': id,
          'quantity': 0
      }
     removeItem(data);
    } else {
      var quantity = 1;
      data = {
        "id": id,
        "quantity": quantity
      }
      data["selling_plan"] = selling_plan;
      addItemToCartFree(data);
    }
  }
  
  
    var total_bliss = 0;
    var total_comfort = 0;
    var total_sleep = 0;
    var total_protect = 0;
    var total_azucare = 0;
    var total_teraslim = 0;
    var total_regulief = 0;
  
  $('body').on('click', '.checkbox-product', function(e) {

    var totalChecked = $('input.checkbox-product:checked').length;
    console.log('totalChecked',totalChecked);

    var planValue = $(this).attr("name");
    var plan = $(this).attr("data-plan");
    var id = $(this).attr("value");
    var selling_plan = $(this).attr("data-selling-plan");
    var section_price = parseFloat($(this).attr("data-price"));
     // console.log('section_price'+section_price);
    
    if(!$(this).is(':checked')) {

      if ($(this).hasClass("bliss-section")) {
        total_bliss = parseFloat(total_bliss) - parseFloat(section_price);
      }
      if ($(this).hasClass("comfort-section")) {
        total_comfort = parseFloat(total_comfort) - parseFloat(section_price);
      }
      if ($(this).hasClass("sleep-section")) {
        total_sleep = parseFloat(total_sleep) - parseFloat(section_price);
      }
      if ($(this).hasClass("protect-section")) {
          total_protect = parseFloat(total_protect) - parseFloat(section_price);
      }
      if ($(this).hasClass("azucare-section")) {
          total_azucare = parseFloat(total_azucare) - parseFloat(section_price);
      }
      if ($(this).hasClass("teraslim-section")) {
          total_teraslim = parseFloat(total_teraslim) - parseFloat(section_price);
      }
      if ($(this).hasClass("regulief-section")) {
          total_regulief = parseFloat(total_regulief) - parseFloat(section_price);
      }
      
      
      data = {
          'id': id,
          'quantity': 0
      }
     removeItem(data);
    } else {

      if ($(this).hasClass("bliss-section")) {
        total_bliss = parseFloat(total_bliss) + parseFloat(section_price);
      }
      if ($(this).hasClass("comfort-section")) {
        total_comfort = parseFloat(total_comfort) + parseFloat(section_price);
      }
      if ($(this).hasClass("sleep-section")) {
        total_sleep = parseFloat(total_sleep) + parseFloat(section_price);
      }
      if ($(this).hasClass("protect-section")) {
          total_protect = parseFloat(total_protect) + parseFloat(section_price);
      }
      if ($(this).hasClass("azucare-section")) {
          total_azucare = parseFloat(total_azucare) + parseFloat(section_price);
      }
      if ($(this).hasClass("teraslim-section")) {
          total_teraslim = parseFloat(total_teraslim) + parseFloat(section_price);
      }
      if ($(this).hasClass("regulief-section")) {
          total_regulief = parseFloat(total_regulief) + parseFloat(section_price);
      }
      
      var quantity = 1;
      if(planValue == 'onetime') {
        quantity = 1;
      }
      
      if(planValue == 'get1free') {
        quantity = 3;
      }
      
      data = {
        "id": id,
        "quantity": quantity
      }
      if(planValue != 'onetime' && planValue != 'get1free') {
        data["selling_plan"] = selling_plan;
      }
      data[plan] = planValue;
      addItemToCartFree(data);
    }

    total_bliss = parseFloat(total_bliss).toFixed(2);
    total_comfort = parseFloat(total_comfort).toFixed(2);
    total_sleep = parseFloat(total_sleep).toFixed(2);
    total_protect = parseFloat(total_protect).toFixed(2);
    total_azucare = parseFloat(total_azucare).toFixed(2);
    total_teraslim = parseFloat(total_teraslim).toFixed(2);
    total_regulief = parseFloat(total_regulief).toFixed(2);
    
    $(".bliss-total").text('$'+total_bliss);
    $(".comfort-total").text('$'+total_comfort);
    $(".sleep-total").text('$'+total_sleep);
    $(".protect-total").text('$'+total_protect);
    $(".azucare-total").text('$'+total_azucare);
    $(".teraslim-total").text('$'+total_teraslim);
    $(".regulief-total").text('$'+total_regulief);

    var checkoutTotal = parseFloat(parseFloat(total_bliss) + parseFloat(total_comfort) + parseFloat(total_sleep) + parseFloat(total_protect) + parseFloat(total_azucare)).toFixed(2);
    $(".checkout-total").text('Checkout - $'+checkoutTotal);
    let discountCode = "protectFreeSpecial";
    // applyCoupon(discountCode);
  });

  function addItemToCartFree(data) {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
         }));
        // OpenDrawer();
      }
    });
  }

  function applyCoupon(discountCode) {
    // Setup the Apply Discount Code URL
    let shopDomain = "www.teranaturals.com";
    let discountApplyUrl = "https://" + shopDomain + "/discount/" + discountCode;
    	
    // Applies discount using hidden iframe to the checkout session
    let i = document.createElement('iframe');
    i.style.display = 'none';
    i.onload = function() { i.parentNode.removeChild(i); };
    i.src=discountApplyUrl;
    document.body.appendChild(i);
  }

  function removeItem(data) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data:data
        }).then(data => {
          console.log("removeddd");
      })
  }
  
  function OpenDrawer(){
       document.documentElement.dispatchEvent(new CustomEvent('product:added', {
         bubbles: true,
              detail: {
                variant: "",
                quantity: 0
              }
          }));
    
    }

  } catch(e) { console.error(e); }
})();
      })();
